export class Token {
    // eslint-disable-next-line no-useless-constructor
    constructor(public expires: number, public token: string) {}

    public static valid(token: any): boolean {
        if (typeof token !== 'object' || token === null) {
            return false;
        }
        if (!('expires' in token) || !('token' in token)) {
            return false
        }
        if (token.expires < (+new Date() / 1000)) { // +new Date() gets current timestamp
            return false;
        }

        return true;
    }
}

export class CSRFToken {
    // eslint-disable-next-line no-useless-constructor
    constructor(public name: string, public token: string) {}

    public static valid(token: any): boolean {
        if (typeof token !== 'object' || token === null) {
            return false;
        }
        if (!('name' in token) || !('token' in token)) {
            return false
        }

        if (token.name === '' || token.token === '' || token.name === null || token.token === null) {
            return false;
        }

        return true;
    }
}
